import {Component} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AlertController, ModalController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import moment, {Moment} from 'moment';
import {AppComponent} from 'src/app/app.component';
import {environment} from 'src/environments/environment';
import {Api} from 'src/smoothr-web-app-core/api/api';
import {OrderStatus} from 'src/smoothr-web-app-core/enums/OrderStatus';
import {PreorderType} from 'src/smoothr-web-app-core/enums/PreorderType';
import Article from 'src/smoothr-web-app-core/models/Article';
import Order from 'src/smoothr-web-app-core/models/Order';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import {RepositoryService} from 'src/smoothr-web-app-core/services/repository/repository.service';
import {OrderUtils} from 'src/smoothr-web-app-core/utils/order-utils';
import {axiosErrorToMessage, numberToCurrency, sleep} from 'src/smoothr-web-app-core/utils/utils';
import {AlertInfoModalComponent} from '../alert-info-modal/alert-info-modal.component';
import {ShowQrComponent} from '../show-qr/show-qr.component';
import {SlotsModalComponent} from '../slots-modal/slots-modal.component';

@Component({
	selector: 'app-show-order-item',
	templateUrl: './show-order-item.component.html',
	styleUrls: ['./show-order-item.component.scss']
})
export class ShowOrderItemComponent {
	order: Order;
	venue: Venue;
	numberToCurrency = numberToCurrency;
	orderUtils = OrderUtils;
	pt = PreorderType;
	os = OrderStatus;
	loading = false;
	moment = moment;
	constructor(
		private modalCtrl: ModalController,
		private snackBarCtrl: MatSnackBar,
		private translate: TranslateService,
		private alertCtrl: AlertController,
		private repository: RepositoryService
	) {}

	static async show(modalCtrl: ModalController, order: Order, venue: Venue): Promise<any> {
		console.log(order);
		const resultScan = await modalCtrl.create({
			component: ShowOrderItemComponent,
			cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
			componentProps: {
				venue,
				order
			}
		});
		await resultScan.present();
		const res = (await resultScan.onDidDismiss()).data;
		await sleep(100);
		return res;
	}
	navigateMap() {
		this.modalCtrl.dismiss();
	}
	hiddenInCart(article: Article): boolean {
		return article.tags && article.tags.find(tag => tag.identifier === 'hide_cart') !== undefined;
	}
	goBack() {
		this.modalCtrl.dismiss();
	}
	async laterHere() {
		this.loading = true;
		if (this.venue) {
		}
		try {
			const venue = await this.repository.getVenue(this.order.venue);
			const slot = await SlotsModalComponent.show(this.modalCtrl, venue, this.order);
			if (slot != null) {
				await this.changeSlot(slot);
			} else {
			}
		} catch (e) {
			this.snackBarCtrl.open(axiosErrorToMessage(this.translate, e), null, {
				duration: 2000
			});
		}
		this.loading = false;
	}

	async changeSlot(time: Moment) {
		this.loading = true;
		if (!(await this.getUserConfirmation(false))) {
			this.loading = false;
			return;
		}
		try {
			this.order = (await Api.changeSlot(this.order, time)).data;
			// this.action.emit(MyOrderActions.onLaterHere);
		} catch (e) {
			this.snackBarCtrl.open(axiosErrorToMessage(this.translate, e), null, {
				duration: 2000
			});
		}
		this.loading = false;
	}

	async getUserConfirmation(isCancel = false, ptType = PreorderType.TAKE_AWAY): Promise<boolean> {
		return AlertInfoModalComponent.show(
			this.modalCtrl,
			this.translate.instant('change_time_alert.title_' + ptType),
			isCancel
				? this.translate.instant('change_time_alert.subtitle_cancel')
				: this.translate.instant('change_time_alert.subtitle'),
			this.translate.instant('change_time_alert.submit'),
			this.translate.instant('change_time_alert.cancel')
		);
	}
	async openQr(orderId: string) {
		await ShowQrComponent.show(this.modalCtrl, environment.urlQrCode + orderId);
	}
	qrCodeString(orderId: string) {
		return environment.urlQrCode + orderId;
	}
	generateQrCode(order: Order) {
		return environment.urlQrCode + order?._id;
	}
}
